export const topTravels = [
  {
    id: 0,
    mean: 'Bus',
    origin: 'Paris',
    destination: 'Amsterdam',
    price: 11,
    url: '/search/paris/amsterdam',
  },
  {
    id: 1,
    mean: 'Train',
    origin: 'Strasbourg',
    destination: 'Paris',
    price: 6,
    url: '/search/strasbourg/paris',
  },
  {
    id: 2,
    mean: 'Bus',
    origin: 'Nice',
    destination: 'Monaco',
    price: 5,
    url: '/search/nice/monaco',
  },
  {
    id: 3,
    mean: 'Train',
    origin: 'Lyon',
    destination: 'Londres',
    price: 34,
    url: '/search/lyon/london',
  },
  {
    id: 4,
    mean: 'Bus',
    origin: 'Paris',
    destination: 'La Rochelle',
    price: 15,
    url: '/search/paris/la-rochelle',
  },
  {
    id: 5,
    mean: 'Train',
    origin: 'Lyon',
    destination: 'Barcelone',
    price: 25,
    url: '/search/lyon/barcelona',
  },
  {
    id: 6,
    mean: 'Train',
    origin: 'Nice',
    destination: 'Paris',
    price: 30,
    url: '/search/nice/paris',
  },
  {
    id: 7,
    mean: 'Bus',
    origin: 'Strasbourg',
    destination: 'Lyon',
    price: 10,
    url: '/search/strasbourg/lyon',
  },
  {
    id: 8,
    mean: 'Bus',
    origin: 'Paris',
    destination: 'Liège',
    price: 9,
    url: '/search/paris/liege',
  },
  {
    id: 9,
    mean: 'Train',
    origin: 'Lyon',
    destination: 'Bordeaux',
    price: 29,
    url: '/search/lyon/bordeaux',
  },
  {
    id: 10,
    mean: 'Train',
    origin: 'Paris',
    destination: 'Marseille',
    price: 26,
    url: '/search/paris/marseille',
  },
  {
    id: 11,
    mean: 'Bus',
    origin: 'Nantes',
    destination: 'Rennes',
    price: 18,
    url: '/search/nantes/rennes',
  },
];
